<script setup lang="ts">
import { format } from 'date-fns'

interface Props {
  value?: string
  seconds?: boolean
}

defineProps<Props>()
</script>

<template>
  <span v-if="value">{{ format(new Date(value), seconds ? 'Ppp' : 'Pp') }}</span>
</template>
